import apiInstance from "../Api/ApiInstance";

export async function ClientRecovery(values) {
  const { email } = values;
  return await apiInstance.get(`api/official-site/user/client/recovery/${email}`);
}
